<button type="button" tabindex="-1" command="show-modal" commandfor="briefTemplateDrawer" class="sr-only"
    aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5 sm:size-6">
        <path d="M10.268 21a2 2 0 0 0 3.464 0" />
        <path
            d="M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326" />
    </svg>
</button>

<el-dialog>
    <dialog #briefTemplateDrawerDialog id="briefTemplateDrawer" aria-labelledby="briefTemplateDrawer-title"
        class="fixed inset-0 size-auto max-h-none max-w-none overflow-hidden bg-transparent backdrop:bg-transparent">
        <el-dialog-backdrop (click)="closeDrawer()"
            class="fixed inset-0 z-10 w-dvw overflow-hidden green-noise-bg opacity-100 transition-opacity ease-in-out data-closed:opacity-0 data-enter:duration-300 data-leave:duration-200">
        </el-dialog-backdrop>
        <div tabindex="0" class="absolute inset-0 pl-10 focus:outline-none sm:pl-16 z-20"
            (click)="$event.stopPropagation()">

            <el-dialog-panel
                class="ml-auto block size-full max-w-xl transform transition-transform ease-in-out data-closed:translate-x-full data-enter:duration-300 data-leave:duration-200 p-4"
                (click)="$event.stopPropagation()">
                <div class="relative flex h-full flex-col overflow-y-auto shadow-xl rounded-xl ">

                    <div class="h-full flex flex-col overflow-hidden divide-y divide-zinc-200 dark:divide-zinc-800">

                        <!-- header -->
                        <div class="shrink-0 px-2 py-4 drawer-header-primary">
                            <div class="flex space-x-3 h-full items-center">
                                <div class="min-w-0 flex-1 px-2">
                                    <p class="text-md font-semibold text-primary">
                                        Brief Templates
                                    </p>
                                    <p class="text-sm text-secondary">
                                        Templates created by you & your team.
                                    </p>
                                </div>

                                <div class="h-full flex flex-col justify-between items-end">

                                    <button type="button" (click)="closeDrawer()"
                                        class="btn-fab-secondary text-secondary">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" class="size-5">
                                            <path d="M18 6 6 18" />
                                            <path d="m6 6 12 12" />
                                        </svg>
                                    </button>

                                </div>
                            </div>
                        </div>
                        <!-- header - END -->

                        <!-- main content -->
                        <div
                            class="relative h-full flex-1 flex-col items-center justify-center w-full overflow-hidden drawer-body-primary divide-y divide-zinc-200 dark:divide-zinc-800">

                            <div class="h-full flex flex-col overflow-y-auto scrollbar-transparent">

                                <!-- Top Filters -->
                                <div
                                    class="shrink-0 flex flex-row items-center justify-between px-2 py-2 border-b border-zinc-200 dark:border-zinc-800">
                                    <nav aria-label="Tabs" class="flex space-x-4">
                                        <a (click)="switchToNew('existing')"
                                            class="rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
                                            [class]="getTabClass('existing')">Existing</a>
                                        <a (click)="switchToNew('new')"
                                            class="rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
                                            [class]="getTabClass('new')">New</a>
                                    </nav>

                                </div>
                                <!-- Top Filters - END -->


                                <!-- Main Content -->

                                @if (currentTab() === 'existing') {
                                <div class="flex-1 flex flex-col">
                                    <!-- Existing Templates -->
                                    @if (associatedTemplates() && associatedTemplates()!.length > 0) {
                                    <ul class="divide-y divide-zinc-200 dark:divide-zinc-800 px-4 py-2" role="list">
                                        @for (template of associatedTemplates()!; track template.id) {
                                        <li
                                            class="flex flex-col gap-3 py-4 sm:flex-row sm:items-center sm:justify-between sm:gap-4">
                                            <div class="min-w-0 flex-1">
                                                <p class="text-sm font-semibold text-primary">
                                                    {{ template.creativeBriefTitle }}</p>
                                                <p class="mt-0.5 text-sm text-secondary">
                                                    Created: {{ formatTemplateCreatedDate(template) || '—' }}
                                                </p>
                                            </div>
                                            <div
                                                class="flex shrink-0 flex-row items-center justify-end gap-2 sm:justify-end">
                                                <button type="button" (click)="useTemplate(template)"
                                                    class="inline-flex items-center justify-center rounded-md border border-zinc-300 bg-white px-3 py-1.5 text-sm font-medium text-primary shadow-xs hover:bg-zinc-50 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary dark:border-white/10 dark:bg-zinc-900 dark:hover:bg-zinc-800">
                                                    Use
                                                </button>
                                                <div class="relative" data-brief-template-options>
                                                    <button type="button"
                                                        [attr.aria-expanded]="isTemplateOptionsOpen(template.id)"
                                                        aria-haspopup="menu"
                                                        [attr.aria-label]="'Options for template ' + template.creativeBriefTitle"
                                                        (click)="toggleTemplateOptionsMenu(template.id, $event)"
                                                        class="inline-flex size-9 items-center justify-center rounded-md border border-transparent text-primary hover:bg-zinc-100 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary dark:hover:bg-zinc-800">
                                                        <span class="sr-only">Open template options</span>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                                            viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"
                                                            class="text-zinc-500 dark:text-zinc-400">
                                                            <circle cx="12" cy="5" r="1.5" />
                                                            <circle cx="12" cy="12" r="1.5" />
                                                            <circle cx="12" cy="19" r="1.5" />
                                                        </svg>
                                                    </button>
                                                    @if (isTemplateOptionsOpen(template.id)) {
                                                    <div role="menu"
                                                        class="absolute right-0 z-30 mt-1 w-36 origin-top-right rounded-md border border-zinc-200 bg-white py-1 shadow-lg dark:border-zinc-700 dark:bg-zinc-900">
                                                        <button type="button" role="menuitem"
                                                            (click)="beginEditTemplate(template, $event)"
                                                            class="block w-full px-3 py-2 text-left text-sm text-primary hover:bg-zinc-50 dark:hover:bg-zinc-800">
                                                            Edit
                                                        </button>
                                                        <button type="button" role="menuitem"
                                                            (click)="confirmDeleteTemplate(template, $event)"
                                                            class="block w-full px-3 py-2 text-left text-sm text-primary hover:bg-zinc-50 dark:hover:bg-zinc-800">
                                                            Delete
                                                        </button>
                                                    </div>
                                                    }
                                                </div>
                                            </div>
                                        </li>
                                        }
                                    </ul>
                                    } @else if (associatedTemplates() && associatedTemplates()!.length === 0) {
                                    <div class="h-full w-full flex flex-col items-center justify-center">
                                        <div class="text-center">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round"
                                                class="mx-auto size-12 text-gray-400 dark:text-gray-500">
                                                <path
                                                    d="M4 11V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.706.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-1" />
                                                <path d="M14 2v5a1 1 0 0 0 1 1h5" />
                                                <path d="M2 15h10" />
                                                <path d="m9 18 3-3-3-3" />
                                            </svg>
                                            <h3 class="mt-2 text-sm font-semibold text-gray-900 dark:text-white">No
                                                Templates</h3>
                                            <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">Get started by
                                                creating a new template.</p>
                                            <div class="mt-6">
                                                <button type="button" (click)="switchToNew('new')"
                                                    class="inline-flex items-center rounded-md bg-primary px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-primary/90 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary dark:bg-primary dark:shadow-none dark:hover:bg-primary/90 dark:focus-visible:outline-primary">
                                                    <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon"
                                                        aria-hidden="true" class="mr-1.5 -ml-0.5 size-5">
                                                        <path
                                                            d="M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z" />
                                                    </svg>

                                                    New Template
                                                </button>
                                            </div>
                                        </div>

                                    </div>
                                    } @else {
                                    <div class="h-full w-full flex flex-col items-center justify-center">
                                        <atom-loading-inline title="Loading Templates"
                                            message="Loading templates..."></atom-loading-inline>
                                    </div>
                                    }
                                    <!-- Existing Templates -->
                                </div>
                                <!-- New Template -->
                                } @else {
                                <div class="flex min-h-0 flex-1 flex-col">
                                    <div class="flex-1 space-y-4 overflow-y-auto px-2 py-4 scrollbar-transparent">
                                        <div
                                            class="p-4 brief-template-card-container">
                                            <label for="brief-new-template-name"
                                                class="block text-sm font-semibold text-primary">Template
                                                Name</label>
                                            <div class="mt-2">
                                                <input [formField]="newTemplateForm.templateName"
                                                    id="brief-new-template-name" type="text" autocomplete="off"
                                                    placeholder="Template Name"
                                                    class="input-primary w-full text-primary" />
                                                @if (saveAttempted() && newTemplateForm.templateName().invalid()) {
                                                <ul class="error-list mt-2">
                                                    @for (error of newTemplateForm.templateName().errors(); track
                                                    $index) {
                                                    <li class="text-error-light flex items-start gap-1 text-sm">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12"
                                                            viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                                            stroke-width="2.5" stroke-linecap="round"
                                                            stroke-linejoin="round" class="mt-0.5 shrink-0"
                                                            aria-hidden="true">
                                                            <path
                                                                d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" />
                                                            <path d="M12 9v4" />
                                                            <path d="M12 17h.01" />
                                                        </svg>
                                                        {{ error.message }}
                                                    </li>
                                                    }
                                                </ul>
                                                }
                                            </div>
                                            <p class="mt-2 text-xs text-secondary" id="brief-new-template-name-hint">
                                                Give your template a name.</p>
                                        </div>

                                        @for (session of [wysiwygSession()]; track session) {

                                        <div
                                            class="divide-y divide-gray-200 overflow-hidden brief-template-card-container">
                                            <div class="px-2 py-2">
                                                <div class="flex space-x-3">
                                                    <div class="flex size-10 shrink-0 items-center justify-center rounded-full bg-primary/10 text-accent border border-primary text-sm font-semibold"
                                                        aria-hidden="true">
                                                        1
                                                    </div>
                                                    <div class="min-w-0 flex-1">
                                                        <p class="text-sm font-semibold text-primary">
                                                            Key Messaging
                                                        </p>
                                                        <p class="text-xs text-secondary">
                                                            What are the main messages you want to convey in the brief and video?
                                                        </p>
                                                    </div>
                                                    <div class="flex shrink-0 self-center">
                                                    </div>
                                                </div>
                                                <div class="pt-2">
                                                    <atom-wysiswyg #keyWysiwyg [inputHtml]="''"
                                                        placeholder="E.g. Our company is launching a new product line..."
                                                        (htmlContentChange)="onKeyMessagingHtml($event)"
                                                        [attr.aria-describedby]="'brief-template-key-msg-desc'"></atom-wysiswyg>
                                                </div>
                                            </div>
                                        </div>


                                        <div
                                            class="divide-y divide-gray-200 overflow-hidden brief-template-card-container">
                                            <div class="px-2 py-2">
                                                <div class="flex space-x-3">
                                                    <div class="flex size-10 shrink-0 items-center justify-center rounded-full bg-primary/10 text-accent border border-primary text-sm font-semibold"
                                                        aria-hidden="true">
                                                        2
                                                    </div>
                                                    <div class="min-w-0 flex-1">
                                                        <p class="text-sm font-semibold text-primary">
                                                            Mandatory items
                                                        </p>
                                                        <p class="text-xs text-secondary" id="brief-template-dos-desc">
                                                            What must be included in the content?
                                                        </p>
                                                    </div>
                                                    <div class="flex shrink-0 self-center">
                                                    </div>
                                                </div>
                                                <div class="pt-2">
                                                    <atom-wysiswyg #doWysiwyg [inputHtml]="''"
                                                        placeholder="E.g. Product demonstration, logo visibility..."
                                                        (htmlContentChange)="onMandatoryItemsHtml($event)"
                                                        [attr.aria-describedby]="'brief-template-dos-desc'"></atom-wysiswyg>
                                                </div>
                                            </div>
                                        </div>

                                        <div
                                            class="divide-y divide-gray-200 overflow-hidden brief-template-card-container">
                                            <div class="px-2 py-2">
                                                <div class="flex space-x-3">
                                                    <div class="flex size-10 shrink-0 items-center justify-center rounded-full bg-primary/10 text-accent border border-primary text-sm font-semibold"
                                                        aria-hidden="true">
                                                        3
                                                    </div>
                                                    <div class="min-w-0 flex-1">
                                                        <p class="text-sm font-semibold text-primary">
                                                            Restrictions
                                                        </p>
                                                        <p class="text-xs text-secondary" id="brief-template-donts-desc">
                                                            What must be avoided in the content?
                                                        </p>
                                                    </div>
                                                    <div class="flex shrink-0 self-center">
                                                    </div>
                                                </div>
                                                <div class="pt-2">
                                                    <atom-wysiswyg #dontWysiwyg [inputHtml]="''"
                                                        placeholder="E.g. No foul language, no competitor mentions..."
                                                        (htmlContentChange)="onRestrictionsHtml($event)"
                                                        [attr.aria-describedby]="'brief-template-donts-desc'"></atom-wysiswyg>
                                                </div>
                                            </div>
                                        </div>
                                        }
                                    </div>

                                    @if (saveFeedback(); as fb) {
                                    <div class="shrink-0 px-2 pb-2" role="status">
                                        <p class="text-sm" [class.text-emerald-600]="fb.kind === 'success'"
                                            [class.dark:text-emerald-400]="fb.kind === 'success'"
                                            [class.text-red-600]="fb.kind === 'error'"
                                            [class.dark:text-red-400]="fb.kind === 'error'">
                                            {{ fb.message }}
                                        </p>
                                    </div>
                                    }

                                    <div
                                        class="drawer-header-primary flex shrink-0 flex-row items-center justify-between border-t border-zinc-200 px-2 py-3 dark:border-zinc-800">

                                        <button (click)="closeDrawer()" type="button"
                                            class="secondary-button inline-flex flex-row items-center gap-x-2">
                                            Cancel
                                        </button>

                                        <button type="button" (click)="saveTemplate()"
                                            class="primary-button inline-flex flex-row items-center gap-x-2"
                                            [disabled]="saving()">
                                            @if (saving()) {
                                            Saving...
                                            } @else {
                                            {{ saveActionLabel() }}
                                            }
                                        </button>
                                    </div>
                                </div>
                                }
                                <!-- New Template - END -->

                                <!-- Main Content - END -->

                            </div>

                        </div>
                        <!-- main content - END -->
                    </div>

                </div>
            </el-dialog-panel>

        </div>
    </dialog>
</el-dialog>